angular
  .module("app")
  .controller("RegisterCustomerCtrl", function (
    $scope,
    $rootScope,
    $userService,
    $location,
    $instantService,
    $storageService,
    $configService,
    Categoria,
    validationService,
    $filter
  ) {
    $scope.state = {
      captcha: false,
      loading: false,
      knownUser: false,
      categoria: Categoria.build({}),
      cf: "",
      piva: "",
      survey: "",
      legalFormRoles: [],
      yearsRoles: [],
      alboRoles: []
    };

    $scope.$storageService = $storageService;

    $scope.init = function () {
      $scope.enabledGenericInput = false;
      localStorage.setItem("captcha-token", "");
      window.recaptchaOnload && window.recaptchaOnload();
      //Get params from url
      var apiKey = $location.search().apiKey;
      if (apiKey) {
        $scope.state.loading = true;
        $instantService
          .validateApiKey(apiKey)
          .then(function (token) {
            //Set the new token
            $configService.init(null, token);
            var token = $configService.getToken();
            //Check the transaction
            $scope.checkTransaction();
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            $scope.state.loading = false;
          });
      }
      $scope.showRecoveryPassword();
      $scope.enabledGenericInput = true;
      $scope.state.legalFormRoles = mockLegalForm();
      $scope.state.yearsRoles = mockYearsRoles();
      $scope.state.alboRoles = mockAlboRoles();
    };

    $scope.restoreLegalFormState = function (chosenLegalForm) {
      $scope.state.categoria = Object.assign(Categoria.build(), {
        legalForm: chosenLegalForm
      });

      $scope.checkInputDate();
    };

    $scope.restoreOtherChoiceState = function (chosenOtherChoice) {
      $scope.state.categoria = Object.assign(Categoria.build(), {
        aziendaAttivaAnniMinimi: chosenOtherChoice
      });
    };

    $scope.checkTransaction = function () {
      $scope.state.loading = true;

      var transactionId = $location.search().transactionId;

      $instantService
        .checkTransaction(transactionId)
        .then(function (appIlTransaction) {
          $scope.state.legalFormRoles = mockLegalForm();
          $scope.state.yearsRoles = mockYearsRoles();
          $scope.state.alboRoles = mockAlboRoles();
          //We don't know the transaction
          if (
            !appIlTransaction ||
            (!appIlTransaction.cfCustomer && !appIlTransaction.pivaCustomer)
          ) {
            $scope.state.transactionId = transactionId;
            $scope.enabledGenericInput = true;
            return;
          }

          //Lock inputs
          //$scope.state.knownUser = true;

          //Default their values
          $scope.state.cf = appIlTransaction.cfCustomer;
          $scope.state.piva = appIlTransaction.pivaCustomer;
          $scope.state.transactionId = transactionId;
          $scope.enabledGenericInput = true;


        })
        .catch(function (err) {
          console.error(err);
          $scope.enabledGenericInput = true;
        })
        .finally(function () {
          $scope.state.loading = false;
        });
    };

    $scope.registerCustomer = function () {
      $scope.state.loading = true;
      var token= localStorage.getItem("captcha-token")
      $userService
        .isUserAllowed(
          $scope.state.cf,
          $scope.state.piva,
          $scope.state.transactionId,
          $scope.state.categoria,
          token
        )
        .then(function (user) {
          console.log("tornato! ", user);

          switch (user.status) {
            case "NEW_USER":
              $location.path("/registerVendor");
              break;
            case "NEW_USER_R":
              $location.path("/");
              break;
            default: {
              localStorage.setItem("cf-registeCustomer", $scope.state.cf)
              $location.url("/login");
              break;
            }
          }
        })
        .catch(function (err) {
          console.log("error: ", err);
          $rootScope.$broadcast("addAlert", {
            text: err.keyMessage
          });
        })
        .finally(function () {
          $scope.state.loading = false;
        });
    };

    var mockLegalForm = function () {
      return propMap["SURVEY_LEGAL_FORM_DOMAIN"];
    };

    var mockYearsRoles = function () {
      return propMap["SURVEY_YEARS_ROLES_DOMAIN"];
    };

    var mockAlboRoles = function () {
      return propMap["SURVEY_ALBO_REGISTRATION_ROLES_DOMAIN"];
    };

    /**
     * Check survery is ok
     */
    var surveyCheck = function () {
      if (
        propMap["SURVEY_ALBO_REGISTRATION_OK"].includes(
          $scope.state.categoria.iscrizioneAlbo) ||
        propMap["SURVEY_YEARS_OK"].includes(
          $scope.state.categoria.aziendaAttivaAnniMinimi) ||
        ("" != $scope.state.categoria.legalForm &&
          propMap["SURVEY_LEGAL_FORM_PROFESSIONAL"].includes(
            $scope.state.categoria.legalForm
          ))
      ) {
        return true;
      }

      return false;
    };

    $scope.isButtonEnabled = function () {
      var isOk = !$scope.state.loading &&
        !$scope.disabledButton &&
        !$scope.isProfessionalOffice &&
        ($scope.customerRegistration &&
          !$scope.customerRegistration.$invalid) &&
        surveyCheck() &&
        localStorage.getItem("captcha-token") && true || false;

      if (isOk) {
        $("#register-customer-forward-button").removeClass("btn-disabled");
      } else {
        $("#register-customer-forward-button").addClass("btn-disabled");
      }
      return isOk;
    };
    window.isButtonEnabled = $scope.isButtonEnabled;
    /**
     * Used to show the error message
     */
    $scope.showAlertMessage = function () {
      return (
        propMap["SURVEY_ALBO_REGISTRATION_NOT_OK"].includes(
          $scope.state.categoria.iscrizioneAlbo
        ) ||
        propMap["SURVEY_YEARS_NOT_OK"].includes(
          $scope.state.categoria.aziendaAttivaAnniMinimi
        )
      );
    };

    $scope.checkInputDate = function (input) {

      var value = input || $scope.state.cf;
      var legalForm = $filter("translate")($scope.state.categoria.legalForm);

      if ((legalForm === "altro" && validationService.isValidCf(value)) ||
        ((legalForm === "libero professionista" || legalForm === "ditta individuale") && validationService.isValidPiva(value))) {

        $scope.disabledButton = true;
      } else {
        $scope.disabledButton = false;
      }

      if (legalForm === "studio professionale") {

        $scope.isProfessionalOffice = true;
      } else {
        $scope.isProfessionalOffice = false;
      }

    }
    $scope.showRecoveryPassword = function () {
      window.recaptchaOnloadLogin();
    };
  });
